import React, { useEffect, useState, useContext } from "react";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import { useLocation } from "react-router-dom";
import Repo from "../../Utility/Repo";
import ModalComponent from "../../Components/ModalComponent";
import UploadFile from "../../Components/UploadFile";
import { TokenContext } from "../../Components/TokenContext";
import ListIsee from "../../Components/ListIsee";
import ListPaymemtsUsers from "../../Components/listPaymentsUser";
import ValidISEE from "../../Components/ValidISEE";
import ValidUser from "../../Components/ValidUser";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}
//  questa chiamata potrebbe essere utile per recuperare i file dell'iscrizione api /Operatore /lista-allegati-iscrizione /{subscriptionId}
function ViewAnnouncements(props) {
  const apiToken = useContext(TokenContext);
  let query = useQuery();
  const [session, setSession] = useState({});
  const [isOpen, toggleModal] = useState(false);
  const [isOpenResult, toggleModalResult] = useState(false);
  const [isOpenError, toggleModalError] = useState(false);
  const [subscriptionsId] = useState(query.get("id"));
  const [messageError, setMessageError] = useState("");
  const [file, setFile] = useState();
  const [showFileToggle, toggleModalShowFile] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const [paymentsTemp, setPaymentsTemp] = useState();
  const [payments, setPayments] = useState();
  const [countRender, setCountRender] = useState(0);

  useEffect(() => {
    if (apiToken) {
      if (query.get("id")) {
        Repo.getSessionByIdUser(apiToken, query.get("id"))
          .then((response) => {
            if (response.status == 200) {
              setSession(response.data);
              setCountRender(1);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
      }
    }
  }, []);

  useEffect(() => {
    if (countRender > 0 && session.subscriptions.length > 0) {
      Repo.getListPaymentUser(apiToken, session.subscriptions[0].id)
        .then((response) => {
          if (response.status == 200) {
            setPaymentsTemp(response.data);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [countRender]);

  const sendSubscription = () => {
    var temp = {
      announcementId: subscriptionsId,
      listBase64: [],
    };

    Repo.postSubscriptionUser(apiToken, JSON.stringify(temp))
      .then((response) => {
        if (response.status == 200) {
          toggleModalResult(true);
          toggleModal(false);
          setTimeout(function () {
            window.location.reload(1);
          }, 2000);
        }
      })
      .catch((error) => {
        if (error.response.status == 400) {
          toggleModalError(true);
          toggleModal(false);
          setMessageError(error.response.data);
        }
        console.log(error);
      });
  };

  const reload = () => {
    window.location.reload(1);
  };

  const bodyFile = () => {
    return (
      <object
        width="100%"
        height="900"
        data={file && file.data}
        type={file && file.type}
      ></object>
    );
  };

  const showFile = (id) => {
    Repo.downloadFileUser(apiToken, id)
      .then((response) => {
        if (response.status == 200) {
          setFile();
          var obj = document.createElement("object");
          obj.type = "application/pdf";
          obj.data = "data:application/pdf;base64," + response.data;
          setFile(obj);

          toggleModalShowFile(!showFileToggle);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const fileListDownload = () => {
    // qui abbiamo il recupero e visualizzazione dei file caricati per il bando dal comune, attualmente sembrano risorse statiche da usare in seguito per 'iscrizione al titolo
    // abbiamo la predisposizione per la modale per la visualizzazione del file caricato dal comune
    return (
      <>
        <hr />
        {session.announcementFiles && session.announcementFiles.length > 0 && (
          <h5 className="mt-4">
            <b>Allegati</b>
          </h5>
        )}
        <div className="row ">
          {session.announcementFiles &&
            session.announcementFiles.length > 0 &&
            session.announcementFiles.map((x, index) => (
              <React.Fragment key={x.storageFileId}>
                <div className="col-2">
                  <button
                    className="btn btn-primary"
                    onClick={() => showFile(x.storageFileId)}
                  >
                    Modulo {index + 1}
                  </button>
                </div>
              </React.Fragment>
            ))}
        </div>
      </>
    );
  };

  return (
    <>
      <ValidISEE />
      <ValidUser />

      <div className="row mb-3">
        <div className="col-lg-9">
          <h1>{session && session.name} </h1>
        </div>
        {session.subscriptions && session.subscriptions.length < 1 ? (
          <div className="col-lg-3">
            <button
              onClick={() => toggleModal(!isOpen)}
              className="btn btn-primary float-right"
            >
              Richiedi intervento
            </button>
          </div>
        ) : session.subscriptions &&
          session.subscriptions[0].state == "VALIDATED" ? (
          <div className="col-lg-3 text-right">
            <svg className="icon icon-success mr-2">
              <use xlinkHref={`${iconSprite}#it-check-circle`}></use>
            </svg>
            <b className="text-success">
              {"Richiesta approvata".toUpperCase()}
            </b>
          </div>
        ) : session.subscriptions &&
          session.subscriptions[0].state == "SUSPENDED" ? (
          <div className="col-lg-3 text-right">
            <svg className="icon icon-dark mr-2">
              <use xlinkHref={`${iconSprite}#it-ban`}></use>
            </svg>
            <b className="text-dark">{"Iscrizione sospesa".toUpperCase()}</b>
          </div>
        ) : session.subscriptions &&
          session.subscriptions[0].state == "ADDED" ? (
          <div className="col-lg-3 text-right">
            <svg className="icon icon-warning mr-2">
              <use xlinkHref={`${iconSprite}#it-warning-circle`}></use>
            </svg>
            <b className="text-warning">{"Richiesta inviata".toUpperCase()}</b>
          </div>
        ) : (
          session.subscriptions &&
          session.subscriptions[0].state == "REFUSED" && (
            <div className="col-lg-3 text-right">
              <svg className="icon icon-danger mr-2">
                <use xlinkHref={`${iconSprite}#it-close-circle`}></use>
              </svg>
              <b className="text-danger">
                {"Richiesta rifiutata".toUpperCase()}
              </b>
            </div>
          )
        )}
      </div>
      <div className="card-wrapper card-space col-lg-12">
        <div className="card card-bg card-big roundedCustom no-after">
          <div className="card-body">
            {session ? (
              <>
                <div className="row">
                  {session.service && (
                    <>
                      <div className="col-lg-4">
                        Categoria:{" "}
                        <span className="text">
                          <b>{session.service.name} </b>
                        </span>
                      </div>
                    </>
                  )}
                </div>
                {session.service && (
                  <div className="row mt-3">
                    <div className="col-lg-12">
                      <span className="text">
                        <p>{session.service.description}</p>
                      </span>
                    </div>
                  </div>
                )}

                {session.subscriptions &&
                  session.subscriptions.length > 0 &&
                  session.subscriptions[0].state == "VALIDATED" && (
                    <div className="row">
                      <div className="col-12">
                        <h6>
                          In seguito all'approvazione della tua richiesta:
                        </h6>
                      </div>
                      <div className="col-12 col-lg-6">
                        <p>
                          Costo Mensile:{" "}
                          <strong>
                            {session.subscriptions[0].cost &&
                              parseFloat(
                                session.subscriptions[0].cost
                              ).toLocaleString("it-IT")}
                            {" € "}
                          </strong>
                        </p>
                      </div>
                      <div className="col-12 col-lg-6">
                        <p>
                          Ore Settimanali:{" "}
                          <strong>{session.subscriptions[0].weeklyHour}</strong>
                        </p>
                      </div>
                    </div>
                  )}

                <hr className="pb-4" />

                <ListIsee bands={session.bands}></ListIsee>
              </>
            ) : (
              <>
                <span className="text">
                  L' intervento selezionato non è presente.
                </span>
              </>
            )}
          </div>
        </div>
      </div>
      {paymentsTemp && paymentsTemp.length > 0 && (
        <ListPaymemtsUsers
          payments={payments}
          paymentsTemp={paymentsTemp}
          setPayments={setPayments}
          userId={query.get("id")}
        />
      )}

      <ModalComponent
        toggleModal={toggleModal}
        isOpen={isOpen}
        header="Iscrizione categoria"
        body="Confermi di voler iscriverti alla categoria scelto"
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => sendSubscription()}
      ></ModalComponent>
      <ModalComponent
        toggleModal={toggleModalResult}
        isOpen={isOpenResult}
        header="Richiesta inviata"
        body="La tua richiesta di iscrizione è stata inviata correttamente"
        buttonConfirm="Ricarica"
        function={() => reload()}
      ></ModalComponent>
      <ModalComponent
        toggleModal={toggleModalError}
        isOpen={isOpenError}
        header="RICHIESTA RIFIUTATA"
        body={messageError}
        buttonConfirm="Chiudi"
        function={() => reload()}
      ></ModalComponent>
      <ModalComponent
        toggleModal={() => toggleModalShowFile(!showFileToggle)}
        isOpen={showFileToggle}
        header={"File"}
        body={bodyFile()}
        buttonDeny="Chiudi"
      ></ModalComponent>
    </>
  );
}

export default ViewAnnouncements;
